export default import.meta.ROLLDOWN_FILE_URL_qbgJnW36p7qWmSFg4IZ0eQ